<div class="top-section">
    <p class="percentage-text">{{ percentage }} %</p>
    @if (badgeText) {
        <p-badge [value]="badgeText" severity="info"></p-badge>
    }
</div>
<p-progressbar [value]="percentage" [showValue]="false" [ngClass]="{ warn: percentage >= 80 }"></p-progressbar>
<p class="label-text">{{ subText }}</p>
